import {createSelector} from '@ngrx/store';
import {selectAllClusters as getClustersRecord} from '../../clusters';
import {getStreamConfigurationsRecord} from '../../stream-configurations/load-all/stream-configurations.load-all.selectors';
import {Cluster, ClusterInstance} from '../../../services/api/clusters/cluster.model';
import {Stream, StreamConfiguration} from '../../../services/api/stream-configurations/stream-configuration.model';
import {getRecords} from './records.selectors';
import {DvrRecord, DvrRecordClipSource} from '../../../services/api/dvr/dvr.model';
import {UUID} from '../../../shared/types/uuid.type';

export const getRecordsForClipSource = createSelector(
  getRecords,
  getClustersRecord,
  getStreamConfigurationsRecord,
  (
    records: DvrRecord[],
    clusters: Cluster[],
    streamConfigurations: StreamConfiguration[]
  ): DvrRecordClipSource[] => {
    if (!records || !records.length || !clusters || !clusters.length) {
      return [];
    }

    if (!streamConfigurations || !streamConfigurations.length) {
      return records
        .filter((record: DvrRecord): boolean => record.status === 'completed' || record.status === 'recording')
        .map((record: DvrRecord): DvrRecordClipSource => {
          return {
            ...record,
            isClusterActive: true
          }
        });
    }

    const inactiveClusters: Cluster[] = clusters.filter((cluster: Cluster): boolean => cluster.status !== 'active');
    const inactiveInstances: ClusterInstance[] = inactiveClusters
      .map((cluster: Cluster): ClusterInstance[] => cluster.instances)
      .flat();
    const inactiveInstancesIds: UUID[] = inactiveInstances.map((instance: ClusterInstance): UUID => instance.id);
    const inactiveStreams: Stream[] = streamConfigurations
      .map((configuration: StreamConfiguration): Stream[] => configuration.streams)
      .flat()
      .filter((stream: Stream): boolean => {
        const instanceId: UUID = stream.instanceId;
        return inactiveInstancesIds.includes(instanceId);
      });
    const inactiveStreamsIds: UUID[] = inactiveStreams.map((stream: Stream): UUID => stream.id);

    return records
      .filter((record: DvrRecord): boolean => record.status === 'completed' || record.status === 'recording')
      .map((record: DvrRecord): DvrRecordClipSource => {
        const streamId: UUID = record.streamId;
        const isClusterActive: boolean = !inactiveStreamsIds.includes(streamId);
        return {
          ...record,
          isClusterActive: isClusterActive
        }
      });
  }
);
